import React from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'

export const RouteChangeTracker = () => {
  const location = useLocation()

  React.useEffect(() => {
    ReactGA.set({ page: location.pathname })
    ReactGA.send({ hitType: 'pageview', page: location.pathname, title: document.title })
  }, [location])

  return <div></div>
}
